import axios from 'axios'


console.log(`${process.env.SERVER_API!}`)

export const serverBackend = axios.create({
  baseURL: `${process.env.SERVER_API!}`,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})
